var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { key: _vm._uid, attrs: { name: "modal" } }, [
    _vm.isActive
      ? _c(
          "div",
          {
            directives: [
              {
                name: "warp",
                rawName: "v-warp:app.prepend",
                arg: "app",
                modifiers: { prepend: true }
              }
            ],
            staticClass: "c-modal"
          },
          [
            _c(
              "div",
              { staticClass: "mask", on: { mousedown: _vm.handleMaskClick } },
              [
                _c(
                  "div",
                  { ref: "container", staticClass: "container" },
                  [
                    _c(
                      "header",
                      [
                        _vm.mobileAction && _vm.mobile
                          ? _c("c-button", {
                              attrs: {
                                size: "lg",
                                icon: "chevron-left",
                                alternative: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.close.apply(null, arguments)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.title
                          ? _c(
                              "c-title",
                              {
                                staticClass: "title",
                                attrs: {
                                  icon: _vm.icon,
                                  "icon-size": "17",
                                  size: "2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.title) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.actions
                          ? _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                _vm._t("actions"),
                                _vm._v(" "),
                                !_vm.mobile
                                  ? _c("c-button", {
                                      attrs: {
                                        "data-cy": "close-cmodal-button",
                                        size: "md",
                                        icon: "cross",
                                        alternative: ""
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.close.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._t("header"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [{ name: "scroll", rawName: "v-scroll" }],
                        staticClass: "body"
                      },
                      [_vm._t("default"), _vm._v(" "), _vm._t("footer")],
                      2
                    )
                  ],
                  2
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55f96a8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55f96a8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CModal.vue
// module id = Em+y
// module chunks = 1624